import { useNavigate, useParams, useLocation, useSearchParams } from "react-router-dom";


export function withNavigation(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const searchParams = useSearchParams();

    // v5-style history for class components
    const history = {
      push: navigate,
      replace: (to, opts) => navigate(to, { ...(opts || {}), replace: true }),
    };

    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={{...params}}
        history={history}
        searchParams={searchParams}
      />
    );
  };
}